import {
  get_time,
  scroll_to_bottom,
  get_messages,
  get_date_from_now,
  is_date_change,
  send_message,
  set_typing,
  is_image,
  get_avatar_html,
} from './wachat_utils';

export default class WachatSpace {
  constructor(opts) {
    this.wachat_list = opts.wachat_list;
    this.$wrapper = opts.$wrapper;
    this.profile = opts.profile;
	this.lasttime = frappe.datetime.now_datetime();
	this.type_msg = null;
	this.timediff = 24;
    this.file = null;

    this.pageSize = 10;
    this.displayStart = 0;
    this.displayEnd = 0;
    this.allMessages = [];

    this.messageIndex = {};
    this.currentReply = null;


    this.setup();
  }

  setup() {
    this.$wachat_space = $(document.createElement('div'));
    this.typing = false;
    this.$wachat_space.addClass('wachat-space');
    this.setup_header();
    this.fetch_and_setup_messages();
    this.setup_socketio();
  }
  updateFloatingButtonVisibility() {
    if (this.displayStart > 0) {
      this.$floating_btn_wrap.show();
    } else {
      this.$floating_btn_wrap.hide();
    }
  }
  
  renderVisibleMessages({ scrollToBottom = false } = {}) {
    this.$wachat_messages.empty();
    this.prevMessage = {};
    

    const slice = this.allMessages.slice(this.displayStart, this.displayEnd);

    slice.forEach(msg => {
      if (msg.message_id) {
        this.messageIndex[msg.message_id] = msg;
      }
      const date_html = this.make_date_line_html(msg.creation);
      if (date_html) this.$wachat_messages.append($(date_html));

      let type = 'recipient';
      if (msg.client == 1) type = 'sender';

      const el = this.make_message(
        msg.content,
        msg.attachment,
        get_time(msg.creation),
        type,
        msg.sender,
        msg.status || '',
        msg.message_id,
        msg.reply_to_message_id
      );

      this.$wachat_messages.append(el);
      this.prevMessage = msg;
    });
  


    this.updateFloatingButtonVisibility();

    if (scrollToBottom) scroll_to_bottom(this.$wachat_space_container);
  }


  loadPreviousBatch() {
    if (this.displayStart <= 0) return;

    const container = this.$wachat_space_container[0];
    const oldHeight = container.scrollHeight;

    this.displayStart = Math.max(0, this.displayStart - this.pageSize);

    this.renderVisibleMessages({ scrollToBottom: false });

    setTimeout(() => {
      const newHeight = container.scrollHeight;
      container.scrollTop += (newHeight - oldHeight);
    }, 10);
  }





  setup_header() {
    this.avatar_html = get_avatar_html(
      this.profile.room_type,
      this.profile.opposite_person_email,
      this.profile.room_name
    );
    const header_html = `
			<div class='wachat-header'>
				${
          this.profile.is_admin === true
            ? `<span class='wachat-back-button' title='${__('Go Back')}' >
								${frappe.utils.icon('left')}
							</span>`
            : ``
        }
				${this.avatar_html}
				<div class='wachat-profile-info'>
					<div class='wachat-profile-name'>
					${__(this.profile.room_name.substring(0,20))}
					<div class='online-circle'></div>
					</div>
					<div class='wachat-profile-status'>${__('Typing...')}</div>
				</div>
			</div>
		`;
    this.$wachat_space.append(header_html);
  }

  async fetch_and_setup_messages() {
    try {
      const res = await get_messages(
        this.profile.room,
        this.profile.user_email
      );
      this.allMessages = Array.isArray(res) ? res.slice() : [];
      const total = this.allMessages.length;
      this.displayEnd = total;
      this.displayStart = Math.max(0, total - this.pageSize);
      
      this.setup_messages(res);
      this.setup_actions();
      this.render();
    } catch (error) {
      frappe.msgprint({
        title: __('Error'),
        message: __('Something went wrong. Please refresh and try again.'),
      });
    }
  }

  // setup_messages(messages_list) {
  //   this.$wachat_space_container = $(document.createElement('div'));
  //   this.$wachat_space_container.addClass('wachat-space-container');

  //   this.make_messages_html(messages_list);

  //   this.$wachat_space_container.html(this.message_html);
  //   this.$wachat_space.append(this.$wachat_space_container);
  // }
  setup_messages() {
    this.$wachat_space_container = $('<div class="wachat-space-container"></div>');
    this.$wachat_space.append(this.$wachat_space_container);

    this.$wachat_messages = $('<div class="wachat-messages"></div>');
    this.$wachat_space_container.append(this.$wachat_messages);

    this.$floating_btn_wrap = $(`
      <div class="wachat-floating-load">
        <button class="wachat-load-prev-btn">Show Previous</button>
      </div>
    `);

    this.$wachat_space.append(this.$floating_btn_wrap);

    this.$floating_btn_wrap.on('click', () => this.loadPreviousBatch());

    this.$wachat_space_container.on('scroll', () => {
      this.updateFloatingButtonVisibility();
    });

    this.renderVisibleMessages({ scrollToBottom: true });
  }



  make_messages_html(messages_list) {
    this.prevMessage = {};
    this.message_html = ``;
    if (this.profile.message) {
      messages_list.push(this.profile.message);
      send_message(
        this.profile.message.content,
        this.profile.user,
        this.profile.room,
        this.profile.user_email
      );
    }
    messages_list.forEach((element) => {
      const date_line_html = this.make_date_line_html(element.creation);
      this.message_html += date_line_html;

      let message_type = 'recipient';

      if (element.sender_email === this.profile.user_email) {
        message_type = 'recipient';
      } else if (this.profile.room_type === 'Guest') {
        if (this.profile.is_admin === true && element.sender !== 'Guest') {
          message_type = 'recipient';
        }
      }
	  if (element.client == 1) {
		message_type = 'sender';
	  }
	  if (message_type == 'sender' && element.is_template == 0){
		this.lasttime = element.creation;
		this.timediff = frappe.datetime.get_hour_diff(frappe.datetime.now_datetime(),this.lasttime);
	  }
      this.message_html += this.make_message(
        element.content,
		element.attachment,
        get_time(element.creation),
        message_type,
        element.sender,
		element.status
      ).prop('outerHTML');

      this.prevMessage = element;
    });
  }

  make_date_line_html(dateObj) {
    let result = `
			<div class='date-line'>
				<span>
					${__(get_date_from_now(dateObj, 'space'))}
				</span>
			</div>
		`;
    if ($.isEmptyObject(this.prevMessage)) {
      return result;
    } else if (is_date_change(dateObj, this.prevMessage.creation)) {
      return result;
    } else {
      return '';
    }
  }

  setup_actions() {
    this.$wachat_actions = $(document.createElement('div'));
    this.$wachat_actions.addClass('wachat-space-actions');
	this.type_msg = `
			<input disabled class='form-control type-message' 
				type='search' 
				placeholder='${__('Exceeded 24 Hrs Send Templates')}'
			>
		`;
	if (this.timediff < 23) {
		this.type_msg = `
			<input class='form-control type-message' 
				type='search' 
				placeholder='${__('Types message')}'
			>
		`;
	}
    const wachat_actions_html = `
			<span class='open-attach-items'>
				${frappe.utils.icon('attachment', 'lg')}
			</span>
			<input type='file' id='wachat-file-uploader' 
				accept='image/*, application/pdf, .doc, .docx'
				style='display: none;'
			>
			${this.type_msg}
			<div>
				<span class='message-send-button'>
					<svg xmlns="http://www.w3.org/2000/svg" width="1.1rem" height="1.1rem" viewBox="0 0 24 24">
						<path d="M24 0l-6 22-8.129-7.239 7.802-8.234-10.458 7.227-7.215-1.754 24-12zm-15 16.668v7.332l3.258-4.431-3.258-2.901z"/>
					</svg>
				</span>
			</div>
		`;
    this.$wachat_actions.html(wachat_actions_html);
    this.$wachat_space.append(this.$wachat_actions);
  }

  async handle_upload_file(file) {
    const dataurl = await frappe.dom.file_to_base64(file.file_obj);
    file.dataurl = dataurl;
    file.name = file.file_obj.name;
    return this.upload_file(file);
  }

  upload_file(file) {
    const me = this;
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('load', () => {
        resolve();
      });

      xhr.addEventListener('error', () => {
        reject(frappe.throw(__('Internal Server Error')));
      });
      xhr.onreadystatechange = () => {
        if (xhr.readyState == XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            let r = null;
            let file_doc = null;
            try {
              r = JSON.parse(xhr.responseText);
              if (r.message.doctype === 'File') {
                file_doc = r.message;
              }
            } catch (e) {
              r = xhr.responseText;
            }
            try {
              if (file_doc === null) {
                reject(frappe.throw(__('File upload failed!')));
              }
              me.handle_send_message(file_doc.file_url);
            } catch (error) {
              //pass
            }
          } else {
            try {
              const error = JSON.parse(xhr.responseText);
              const messages = JSON.parse(error._server_messages);
              const errorObj = JSON.parse(messages[0]);
              reject(frappe.throw(__(errorObj.message)));
            } catch (e) {
              // pass
            }
          }
        }
      };

      xhr.open('POST', '/api/method/upload_file', true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Frappe-CSRF-Token', frappe.csrf_token);

      let form_data = new FormData();

      form_data.append('file', file.file_obj, file.name);
      form_data.append('is_private', +false);

      form_data.append('doctype', 'Wachat Room');
      form_data.append('docname', this.profile.room);
      form_data.append('optimize', +true);
      xhr.send(form_data);
    });
  }

  open_file_uploader() {
	const me = this;
	let restrictions = {
		allowed_file_types: []
	};
	let options = {
		allow_multiple: true,
		restrictions: restrictions,
		on_success: (file) => {
			frappe.db.get_doc('File', file.name)
			.then(filedoc => {
				console.log(filedoc);
				this.$wachat_space_container.append(
					this.make_message('Media Attachment', filedoc.file_url, get_time(), 'recipient', this.profile.user)
				);
			})
			alert('Success');
		},
	};
	options.doctype = 'Wachat Room';
	options.docname = this.profile.room;
	options.disable_file_browser = 1;
	new frappe.ui.FileUploader(options);
  }

  setup_events() {
    const me = this;

    // ✅ Reply click handler
    this.$wachat_space.on('click', '.message-bubble', function () {
      const id = $(this).attr('data-message-id');
      if (!id) return;

      me.currentReply = id;

      $('.type-message')
        .attr('placeholder', 'Replying to message...')
        .css({
          border: '2px solid green',
          'background-color': '#f6fff6'
        });
    });


    //Timeout function
    me.typing_timeout = () => {
      me.typing = false;
    };

    $('.wachat-back-button').on('click', function () {
      me.wachat_list.render_messages();
      me.wachat_list.render();
    });

    $('.open-attach-items').on('click', function () {
      me.open_file_uploader();
    });

    $('#wachat-file-uploader').on('change', function () {
      if (this.files.length > 0) {
        me.file = {};
        me.file.file_obj = this.files[0];
        me.handle_upload_file(me.file);
        me.file = null;
      }
    });

    $('.message-send-button').on('click', function () {
      me.handle_send_message();
    });

    $('.type-message').keydown(function (e) {
      if (e.which === 13) {
        me.handle_send_message();
      } else {
        //Set as typing
        if (me.typing === false) {
          me.typing = true;
          set_typing(
            me.profile.room,
            me.profile.user_email,
            me.typing,
            !me.profile.is_admin
          );
          me.timeout = setTimeout(me.typing_timeout, 3000);
        }
      }
    });
  }

  setup_socketio() {
    const me = this;

    frappe.realtime.on(this.profile.room, function (res) {
      me.receive_message(res, get_time(res.creation));
    });

    frappe.realtime.on(this.profile.room + ':typing', function (res) {
      me.get_typing_changes(res);
    });
  }

  destroy_socket_events() {
    frappe.realtime.off(this.profile.room);
    frappe.realtime.off(this.profile.room + ':typing');
  }

  get_typing_changes(res) {
    if (res.user != this.profile.user_email) {
      if (
        (this.profile.is_admin === true && res.is_guest === 'true') ||
        this.profile.is_admin === false ||
        this.profile.room_type === 'Group' ||
        this.profile.room_type === 'Direct'
      ) {
        if (res.is_typing === 'false') {
          $('.wachat-profile-status').css('visibility', 'hidden');
        } else {
          $('.wachat-profile-status').css('visibility', 'visible');
          const timeout = setTimeout(() => {
            $('.wachat-profile-status').css('visibility', 'hidden');
          }, 3000);
        }
      }
    }
  }

  make_message(content, attachment, time, type, name, status, message_id = null, reply_id = null) {

    const message_class = type === 'recipient' ? 'recipient-message' : 'sender-message';
    const $recipient_element = $('<div>').addClass(message_class);
    const $message_element = $('<div>').addClass('message-bubble');

    // attach message id for click
    if (message_id) {
      $message_element.attr('data-message-id', message_id);
    }

    // ✅ show reply preview
    if (reply_id && this.messageIndex[reply_id]) {
      const original = this.messageIndex[reply_id];

      const $replyBlock = $(`
        <div class="reply-preview">
          <strong>${original.sender}</strong><br>
          <span>${(original.content || '').substring(0, 50)}</span>
        </div>
      `);

      $message_element.append($replyBlock);
    }

    // message text
    const $content = $('<div>').text(content);

    if (type === 'sender' && this.profile.room_type === 'Group') {
      const $name_element = $('<div>').addClass('message-name').text(name);
      $message_element.append($name_element);
    }

    $message_element.append($content);

    $recipient_element.append($message_element);
    $recipient_element.append(`<div class="message-time">${time}</div>`);

    if (type === 'recipient') {
      $recipient_element.append(`<div class="message-time">Sent by ${name}</div>`);
    }

    if (status) {
      $recipient_element.append(`<div class="message-time">Status: ${status}</div>`);
    }

    return $recipient_element;
  }



//   make_message(content, attachment, time, type, name, status, reply_id = null) {
//     if (reply_id) {
//     const $replyBox = $(`
//         <div class="reply-preview">
//             Replying to: ${reply_id}
//         </div>
//     `);
//     $message_element.append($replyBox);
// }

//     const message_class =
//       type === 'recipient' ? 'recipient-message' : 'sender-message';
//     const $recipient_element = $(document.createElement('div')).addClass(
//       message_class
//     );
//     const $message_element = $(document.createElement('div')).addClass(
//       'message-bubble'
//     );

//         // ✅ attach message_id attribute
//     if (reply_id) {
//       $message_element.attr('data-message-id', reply_id);
//     }

//     // ✅ reply preview block
//     if (reply_id) {
//       const $reply_block = $(`
//         <div class="reply-preview">
//           <strong>${sender}</strong><br>
//           <span>${preview}</span>
//         </div>
//       `);
//       const original = this.messageIndex[reply_id];

//       let preview = 'Message not found';
//       let sender = '';

//       if (original) {
//         preview = (original.content || '').substring(0, 60);
//         sender = original.sender || '';
//       }

      

//       $message_element.append($reply_block);
//     }


//     const $name_element = $(document.createElement('div'))
//       .addClass('message-name')
//       .text(name);
	
// 	const $attach_element = $(document.createElement('div'))
//       .addClass('message-name')
//       .text('Media Attachment');

// 	const $caption_element = $(document.createElement('div'))
//       .addClass('message-caption')
//       .text("Caption: " + content);

//     const n = content.lastIndexOf('/');
//     const file_name = content.substring(n + 1) || '';
//     let $sanitized_content;

//     if (content.startsWith('/files/') && file_name !== '') {
//       let $url;
//       if (is_image(file_name)) {
//         $url = $(document.createElement('img'));
//         $url.attr({ src: content }).addClass('img-responsive wachat-image');
//         $message_element.css({ padding: '0px', background: 'inherit' });
//         $name_element.css({
//           color: 'var(--text-muted)',
//           'padding-bottom': 'var(--padding-xs)',
//         });
//       } else {
//         $url = $(document.createElement('a'));
//         $url.attr({ href: attachment, target: '_blank' }).text(__('Download'));

//         if (type === 'sender') {
//           $url.css('color', 'var(--cyan-100)');
//         }
//       }
//       $sanitized_content = $url;
//     }
// 	else if ((attachment) && (attachment !== '') && (attachment.startsWith('https'))) {
//       let $url;
//       if (is_image(file_name)) {
//         $url = $(document.createElement('img'));
//         $url.attr({ src: content }).addClass('img-responsive wachat-image');
//         $message_element.css({ padding: '0px', background: 'inherit' });
//         $name_element.css({
//           color: 'var(--text-muted)',
//           'padding-bottom': 'var(--padding-xs)',
//         });
//       } else {
//         $url = $(document.createElement('a'));
//         $url.attr({ href: attachment, target: '_blank' }).text(__('Download'));

//         if (type === 'sender') {
//           $url.css('color', 'var(--cyan-100)');
//         }
//       }
// 	  $message_element.append($attach_element);
// 	  $message_element.append($caption_element);
//       $sanitized_content = $url;
//     }
// 	else {
//       $sanitized_content = __($('<div>').text(content).html());
//     }

//     if (type === 'sender' && this.profile.room_type === 'Group') {
//       $message_element.append($name_element);
//     }
//     $message_element.append($sanitized_content);
//     $recipient_element.append($message_element);
//     $recipient_element.append(`<div class='message-time'>${__(time)}</div>`);
// 	if (type === 'recipient') {
// 	  $recipient_element.append(`<div class='message-time'>Sent by ${name}</div>`);
// 	}
// 	if (status) {
// 	  $recipient_element.append(`<div class='message-time'>Msg Status: ${status}</div>`);
// 	}
//     return $recipient_element;
//   }

  handle_send_message(attachment) {
    const $type_message = $('.type-message');
    let content = attachment ? attachment : $type_message.val();

    if (!content || content.length === 0) {
      return;
    }

    this.typing = false;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    if (
      this.profile.is_admin === true &&
      frappe.Wachat.settings.user.enable_message_tone === 1
    ) {
      frappe.utils.play_sound('wachat-message-send');
    }

    const now = frappe.datetime.now_datetime();

 
    const localMsg = {
      content: content,
      attachment: attachment || '',
      sender: this.profile.user,
      creation: now,
      sender_email: this.profile.user_email,
      client: 1,
      is_template: 0,
      status: ''
    };

    this.allMessages.push(localMsg);


    this.displayEnd = this.allMessages.length;

    if (this.displayEnd - this.displayStart > this.pageSize) {
      this.displayStart = Math.max(0, this.displayEnd - this.pageSize);
    }

    
    this.renderVisibleMessages({ scrollToBottom: true });

    $type_message.val('');


    send_message(
      content,
      this.profile.user,
      this.profile.room,
      this.profile.user_email,
      this.currentReply
    );

    this.updateFloatingButtonVisibility();
    this.currentReply = null;
    $('.type-message')
      .attr('placeholder', 'Type message')
      .css('border', '');

  }




  receive_message(res, time) {
    if (res.sender_email === this.profile.user_email) {
      return;
    }

    let wachat_type = 'sender';
    if (this.profile.room_type === 'Guest') {
      if (this.profile.is_admin === true && res.user !== 'Guest') {
        wachat_type = 'recipient';
      }
    }

    
    const incomingMsg = {
      content: res.content,
      attachment: res.content,
      sender: res.user,
      creation: res.creation || frappe.datetime.now_datetime(),
      sender_email: res.sender_email,
      client: 0,
      is_template: 0,
      status: res.status || '',
      message_id: res.message_id,
      reply_to_message_id: res.reply_to_message_id
    };

    this.allMessages.push(incomingMsg);


    this.displayEnd = this.allMessages.length;

    if (this.displayEnd - this.displayStart > this.pageSize) {
      this.displayStart = Math.max(0, this.displayEnd - this.pageSize);
    }


    this.renderVisibleMessages({ scrollToBottom: true });


    if (
      this.profile.is_admin === true &&
      $('.wachat-element').is(':visible') &&
      frappe.Wachat.settings.user.enable_message_tone === 1
    ) {
      frappe.utils.play_sound('wachat-message-receive');
    }
  }


  render() {
    this.$wrapper.html(this.$wachat_space);
    this.setup_events();

    scroll_to_bottom(this.$wachat_space_container);
  }
}